<template>
  <div id="option">
    <div class="option" v-if="optionIndex == '1'">
      <h2>请选择登录身份</h2>
      <div class="container">
        

        <div class="item1" @click="loginItem('2')">
          <div></div>
          <p>回收商</p>
        </div>
        
        <div class="item" @click="loginItem('1')">
          <div></div>
          <p>委托方</p>
        </div>
      </div>
    </div>
    <div class="option" v-else-if="optionIndex == '2'">
      <h2>请选择注册身份</h2>
      <div class="container">
        

        <div class="item1" @click="loginItem('2')">
          <div></div>
          <p>回收商</p>
        </div>
        <div class="item" @click="loginItem('1')">
          <div></div>
          <p>委托方</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    props: {
      // 1.登录信号  2.注册信号
      optionIndex: String
    },
    created() {

    },
    methods: {
      loginItem(index) {
        if (this.optionIndex == '1') {
          if (index == '1') {
            this.$router.push({
              path: '/weiTuo',
              query: {
                redirect: location.hostname // router对象自带的属性
              }
            })
          } else if (index == '2') {
            // 回收商登录
            this.$router.push({
              path: '/huiShou',
              query: {
                redirect: location.hostname // router对象自带的属性
              }
            })
          }
        } else if (this.optionIndex == '2') {
          if (index == '1') {
            console.log('111')
            this.$router.push({
              path: '/weiTuoRegister',
              query: {
                redirect: location.hostname // router对象自带的属性
              }
            })
          } else if (index == '2') {
            this.$router.push({
              path: '/huiShouRegister',
              query: {
                redirect: location.hostname // router对象自带的属性
              }
            })
          }
        }
      }

    }
  }
</script>

<style scoped lang="scss">
  #option {
    width: 660px;
    height: 367px;

    .option {
      width: 100%;
      height: 100%;
      text-align: center;
      padding-top: 50px;

      .container {
        width: 300px;
        height: 130px;
        display: flex;
        justify-content: space-between;
        margin: 0 auto;
        margin-top: 40px;

        .item {
          width: 120px;
          height: 130px;
          cursor: pointer;
          border-radius: 10px;
          border: #D8D8D8 1px solid;

          div {
            width: 50px;
            height: 50px;
            margin: 0 auto;
            margin-top: 24px;
            background-image: url('../assets/img/all/weituo.png');
          }

          p {
            font-size: 16px;

          }
        }

        .item:hover {
          border: #D43733 1px solid;
          color: #D43733;

          div {
            background-image: url('../assets/img/all/weituoisActive.png');
          }
        }

        .item1 {
          width: 120px;
          height: 130px;
          cursor: pointer;
          border-radius: 10px;
          border: #D8D8D8 1px solid;

          div {
            width: 50px;
            height: 50px;
            margin: 0 auto;
            margin-top: 24px;
            background-image: url('../assets/img/all/huishou.png');
          }

          p {
            font-size: 16px;
          }
        }

        .item1:hover {
          border: #D43733 1px solid;
          color: #D43733;

          div {
            background-image: url('../assets/img/all/huishouisActive.png');
          }
        }


      }
    }
  }
</style>